import { ICellRendererParams } from '@ag-grid-community/core';
import { Form, Formik } from 'formik';
import { toFormikValidationSchema } from 'zod-formik-adapter';

import { CurrencyTextField } from 'src/components/textfield/CurrencyTextField';
import { priceSchema } from 'src/routes/payments/services/components/AddPrice';
import { SubscriptionInterval } from 'src/routes/payments/subscriptions/types/subscriptions';
import { getRenderCurrencyPrefixProps } from 'src/routes/payments/utils/currencyInputUtils';
import { PriceType } from 'src/services/api/productsApi';
import {
  GetCurrencyPrefix,
  StripeCurrencyFormatterAdapter,
} from 'src/utils/PaymentsUtils';

export const PriceCellRenderer = (params: ICellRendererParams) => {
  const mode = params.colDef?.cellRendererParams.mode;
  const defaultCurrency =
    params.colDef?.cellRendererParams?.defaultCurrency || '';
  const productId =
    params.colDef?.cellRendererParams?.productId || params.data.productId || '';

  if (!params.data.isNew) {
    return StripeCurrencyFormatterAdapter({
      value:
        typeof params.data.amount === 'number'
          ? params.data.amount
          : params.data.amount * 100,
      currency: defaultCurrency,
    });
  }

  const prefix = GetCurrencyPrefix({ currency: defaultCurrency });

  return (
    <Formik
      initialValues={{
        amount: params.data.amount ?? '',
        currency: params.data.currency ?? '',
        productId: productId,
        type: mode === 'OneTimeStore' ? PriceType.OneTime : PriceType.Recurring,
        interval: params.data.interval ?? SubscriptionInterval.Month,
      }}
      validationSchema={toFormikValidationSchema(priceSchema)}
      onSubmit={(values) => {
        params.node.setDataValue('amount', values.amount);
        params.node.setDataValue('currency', values.currency);
        params.node.setDataValue('interval', values.interval);
      }}
      enableReinitialize
    >
      {({ values, errors, handleChange, handleBlur }) => {
        params.colDef?.cellRendererParams?.setPriceError(
          errors ? errors.amount : null,
        );
        return (
          <Form>
            <CurrencyTextField
              name="amount"
              variant="outlined"
              fullWidth
              onBlur={handleBlur}
              onChange={(e) => {
                handleChange(e);
                params.node.setDataValue('amount', e.target.value);
              }}
              autoFocus
              InputProps={getRenderCurrencyPrefixProps(prefix || '')}
              value={values.amount}
              error={Boolean(errors.amount)}
              currency={defaultCurrency}
              className="[&>div>input]:!text-base [&>div>input]:!h-8 [&>div>input]:!font-normal [&>div>input]:!text-black-heading"
            />
          </Form>
        );
      }}
    </Formik>
  );
};
